import React, { useEffect, useState } from 'react';
//@ts-ignore
import { useIdleTimer } from 'react-idle-timer/legacy';
import { useCIAMAuth } from '../hooks/useCIAMAuth';
import { ErrorBoundary } from 'react-error-boundary';
import { ExtendSession } from './ExtendSession';
import SessionTimerPopUp from '../sessionTimer/SessionTimerPopUp';
import { Debug } from './Debug';
import { Metadata } from '@ciam/analytics';

export const KeepLive = (props: any) => {
  let initialExtendTime: number = 1000 * 60 * 9; // 9 minutes
  let initialIdleTime: number = 1000 * 60 * 10;// 10 minutes
  let initialPopupTimer: number = 300; // 5 minutes
  let expTime: number = 16 * 60; // 16 minutes

  const logOutLoad = props.logOutLoad;
  const [extendTime, setExtendTime] = useState(initialExtendTime);
  const [idleTime, setIdleTime] = useState(initialIdleTime);
  const [token, setToken] = useState('');
  const ciamAuth = useCIAMAuth();
  const jwtToken = ciamAuth.ciamSession ? ciamAuth.ciamSession.jwtToken : null;
  const [lastSessionExtendedAt, setLastSessionExtendedAt] = useState("");
  const [state, setState] = useState('Active');
  const [showSessionPopUp, setShowSessionPopUp] = useState(false);
  const [popupTimer, setPopupTimer] = useState(initialPopupTimer);
  const [displayCountdown, setDisplayCountdown] = useState(popupTimer);

  const onIdle = () => {
    console.log(new Date(), "User is going to idle state");
    setState('Idle');
  };

  const onActive = () => {
    if (!showSessionPopUp) {
      console.log(new Date(),"User is going to active state");
      setState('Active');
      props.onSessionValidate();
    }
  };
  const onAction = () => { }

  const handleContinue = () => {
    setState('Active');
    setShowSessionPopUp(false);
    props.onSessionValidate();
  }


  const handleLogout = (inactivity?: boolean) => {
    props.logOut && props.logOut(false, inactivity);
    setShowSessionPopUp(false);
  };

  const { getRemainingTime } = useIdleTimer({
    onIdle,
    onActive,
    onAction,
    timeout: idleTime,
    throttle: 1000,
  });

  useEffect(() => {
    if (ciamAuth?.config?.debugMode) {
      console.log("Updating the timer...");
      setExtendTime(ciamAuth?.config?.initialExtendTime || initialExtendTime);
      setIdleTime(ciamAuth?.config?.idleTime || initialIdleTime);
      setPopupTimer(ciamAuth?.config?.popupTimer || popupTimer);
    }
  }, [ciamAuth?.config?.initialExtendTime, ciamAuth?.config?.idleTime, ciamAuth?.config?.popupTimer]);

  useEffect(() => {
    if(state == 'Active') return;
    const interval = setInterval(() => {
      const exp = ciamAuth?.ciamSession?.ciamUser?.exp;
      const timeToExpire = exp !== undefined ? (((exp - expTime) * 1000 - Date.now()) / 1000) : 0;
      const timerCheck = timeToExpire < popupTimer;
      // popup is present but token is extended
      if(showSessionPopUp && exp !== undefined && !timerCheck) {
        setShowSessionPopUp(false);
      }
      if (
        state == 'Idle' &&
        !showSessionPopUp &&
        timerCheck && 
        !logOutLoad
      ) {
        if(timeToExpire <= 0) {
          handleLogout(true);
          return;
        }
        setShowSessionPopUp(true);
        setDisplayCountdown(timeToExpire < popupTimer ? Math.floor(timeToExpire) : popupTimer);
        const appId = ciamAuth?.config?.appId || 'ciam';
        ciamAuth?.tag && ciamAuth.tag({ event: "pageView", command: "trackEvent", properties: {
                        pageName:`${appId}:login:session timeout`,
                        platform:`${appId} portal`,
                        siteSection:"login",
                        subSiteSection:"session timeout"
                      } } as Metadata);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [state, showSessionPopUp, popupTimer, ciamAuth?.ciamSession?.ciamUser?.exp, logOutLoad]);

  useEffect(() => {
    if (state == 'Active' && ciamAuth.ciamSession && jwtToken && ciamAuth.ciamSession.ciamUser && ciamAuth.ciamSession.ciamUser.iat) {
      setToken(jwtToken);
      const tokenExp = new Date(ciamAuth.ciamSession.ciamUser.iat * 1000);
      setLastSessionExtendedAt(tokenExp.toString());
      let remainingTime = ((ciamAuth?.config?.initialExtendTime || initialExtendTime) - (new Date().valueOf() - tokenExp.valueOf()));
      setExtendTime(remainingTime < 0 ? 30 * 1000 : remainingTime);
    }
  }, [state, ciamAuth.ciamSession, jwtToken]);

  // Timer countdown for session popup
  useEffect(() => {
    if (!showSessionPopUp) return;
    if (displayCountdown <= 0) return;
    
    const interval = setInterval(() => {
      setDisplayCountdown(prev => {
        if (prev <= 1) {
          handleLogout(true);
          clearInterval(interval);
          setShowSessionPopUp(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [showSessionPopUp]);

  const  formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  }

  return (
    <>
      {ciamAuth.config.debugMode && (
        <Debug extendTime={extendTime} getRemainingTime={getRemainingTime} state={state} popupTimer={popupTimer}/>
      )}
      <SessionTimerPopUp
        isOpen={showSessionPopUp}
        countdown={formatTime(displayCountdown)}
        onContinue={handleContinue}
        onLogout={handleLogout}
      />
      <ErrorBoundary fallback="Failed">
        <ExtendSession state={state} token={token} extendTime={extendTime} onSessionExtend={props.onSessionExtend}></ExtendSession>
      </ErrorBoundary>
      {/* {state == 'Active' ? (
        
      ) : null} */}
    </>
  );
};
